import styled from "styled-components";

export const Container = styled.div`
  padding-top: 1vh;
  padding-bottom: 2vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Logo = styled.img`
  width: 104px;
  height: 49px;
`;
